import MBModal from '../../../../../../shared/components/modals/MBModal';
import ShipmentHistoryTable from './ShipmentHistoryTable';

interface ShipmentHistoryModalProps {
  open: boolean;
  onClose: () => void;
  selectedShipmentRow?: any;
}

const ShipmentHistoryModal = ({
  open,
  onClose,
  selectedShipmentRow = {},
}: ShipmentHistoryModalProps) => {
  return (
    <MBModal
      title={`Shipment History${
        selectedShipmentRow ? ` - ${selectedShipmentRow.voyageNumber}` : ''
      }`}
      onClose={onClose}
      open={open}
      maxWidth='lg'
    >
      <ShipmentHistoryTable selectedShipmentRow={selectedShipmentRow} />
    </MBModal>
  );
};

export default ShipmentHistoryModal;
